import { gql } from '@apollo/client';

// ==================== CREATIVE MUTATIONS ====================

export const CREATE_CREATIVE = gql`
  mutation CreateCreative($input: CreateCreativeInput!) {
    createCreative(input: $input) {
      id
      userID
      creativeType
      visualTypes
      status
      projectCount
      packageCount
      canBePublished
      profilePicture
      displayName
      jobTitle
      description
      skills
      averageRating
      reviewCount
      viewCount
      user {
        id
        firstName
        lastName
        profilePicture
      }
      packages {
        nextToken
      }
      projects {
        nextToken
      }
      studios {
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_CREATIVE = gql`
  mutation UpdateCreative(
    $input: UpdateCreativeInput!
    $condition: ModelCreativeConditionInput
  ) {
    updateCreative(input: $input, condition: $condition) {
      id
      userID
      creativeType
      visualTypes
      status
      projectCount
      packageCount
      canBePublished
      profilePicture
      displayName
      jobTitle
      description
      skills
      averageRating
      reviewCount
      viewCount
      user {
        id
        firstName
        lastName
        profilePicture
      }
      packages {
        items {
          id
          name
          packageType
          price
          isActive
          status
        }
        nextToken
      }
      projects {
        items {
          id
          title
          status
          viewCount
        }
        nextToken
      }
      studios {
        items {
          id
          studioID
          creativeID
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_CREATIVE = gql`
  mutation DeleteCreative(
    $input: DeleteCreativeInput!
    $condition: ModelCreativeConditionInput
  ) {
    deleteCreative(input: $input, condition: $condition) {
      id
      userID
      creativeType
      visualTypes
      status
      profilePicture
      displayName
      jobTitle
      description
      createdAt
      updatedAt
    }
  }
`;

export const PUBLISH_CREATIVE = gql`
  mutation PublishCreative($id: ID!) {
    publishCreative(id: $id) {
      id
      userID
      creativeType
      visualTypes
      status
      projectCount
      packageCount
      canBePublished
      profilePicture
      displayName
      jobTitle
      description
      skills
      averageRating
      reviewCount
      viewCount
      createdAt
      updatedAt
    }
  }
`;

// ==================== CREATIVE PACKAGE MUTATIONS ====================

export const CREATE_CREATIVE_PACKAGE = gql`
  mutation CreateCreativePackage($input: CreateCreativePackageInput!) {
    createCreativePackage(input: $input) {
      id
      creativeID
      serviceType
      name
      description
      packageType
      duration
      price
      pricePerHour
      deliverables
      includedServices
      deliveryTime
      portfolioImages
      equipment
      isPopular
      order
      bookingCount
      averageRating
      isActive
      status
      creative {
        id
        displayName
        profilePicture
        creativeType
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_CREATIVE_PACKAGE = gql`
  mutation UpdateCreativePackage(
    $input: UpdateCreativePackageInput!
    $condition: ModelCreativePackageConditionInput
  ) {
    updateCreativePackage(input: $input, condition: $condition) {
      id
      creativeID
      serviceType
      name
      description
      packageType
      duration
      price
      pricePerHour
      deliverables
      includedServices
      deliveryTime
      portfolioImages
      equipment
      isPopular
      order
      bookingCount
      averageRating
      isActive
      status
      creative {
        id
        displayName
        profilePicture
        creativeType
        visualTypes
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_CREATIVE_PACKAGE = gql`
  mutation DeleteCreativePackage(
    $input: DeleteCreativePackageInput!
    $condition: ModelCreativePackageConditionInput
  ) {
    deleteCreativePackage(input: $input, condition: $condition) {
      id
      creativeID
      name
      packageType
      price
      status
      createdAt
      updatedAt
    }
  }
`;

// ==================== CREATIVE PROJECT MUTATIONS ====================

export const CREATE_CREATIVE_PROJECT = gql`
  mutation CreateCreativeProject($input: CreateCreativeProjectInput!) {
    createCreativeProject(input: $input) {
      id
      creativeID
      title
      description
      images {
        url
        caption
        thumbnailUrl
        order
      }
      audios {
        url
        title
        artists
        genre
        coverImage
        order
        durationMs
      }
      category
      tags
      status
      viewCount
      studioID
      creative {
        id
        displayName
        profilePicture
        creativeType
        visualTypes
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_CREATIVE_PROJECT = gql`
  mutation UpdateCreativeProject(
    $input: UpdateCreativeProjectInput!
    $condition: ModelCreativeProjectConditionInput
  ) {
    updateCreativeProject(input: $input, condition: $condition) {
      id
      creativeID
      title
      description
      images {
        url
        caption
        thumbnailUrl
        order
      }
      audios {
        url
        title
        artists
        genre
        coverImage
        order
        durationMs
      }
      category
      tags
      status
      viewCount
      studioID
      creative {
        id
        displayName
        profilePicture
        creativeType
        visualTypes
        userID
        user {
          id
          firstName
          lastName
          profilePicture
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_CREATIVE_PROJECT = gql`
  mutation DeleteCreativeProject(
    $input: DeleteCreativeProjectInput!
    $condition: ModelCreativeProjectConditionInput
  ) {
    deleteCreativeProject(input: $input, condition: $condition) {
      id
      creativeID
      title
      status
      createdAt
      updatedAt
    }
  }
`;

// ==================== STUDIO CREATIVE MUTATIONS ====================

export const CREATE_STUDIO_CREATIVE = gql`
  mutation CreateStudioCreative($input: CreateStudioCreativeInput!) {
    createStudioCreative(input: $input) {
      id
      studioID
      creativeID
      studio {
        id
        StudioName
        images
        studioLocation
        city
        country
        User {
          id
          firstName
          lastName
          profilePicture
        }
      }
      creative {
        id
        displayName
        profilePicture
        jobTitle
        description
        creativeType
        visualTypes
        averageRating
        reviewCount
        userID
        user {
          id
          firstName
          lastName
          profilePicture
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_STUDIO_CREATIVE = gql`
  mutation UpdateStudioCreative(
    $input: UpdateStudioCreativeInput!
    $condition: ModelStudioCreativeConditionInput
  ) {
    updateStudioCreative(input: $input, condition: $condition) {
      id
      studioID
      creativeID
      studio {
        id
        StudioName
        images
        studioLocation
        city
        country
      }
      creative {
        id
        displayName
        profilePicture
        creativeType
        visualTypes
      }
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_STUDIO_CREATIVE = gql`
  mutation DeleteStudioCreative(
    $input: DeleteStudioCreativeInput!
    $condition: ModelStudioCreativeConditionInput
  ) {
    deleteStudioCreative(input: $input, condition: $condition) {
      id
      studioID
      creativeID
      createdAt
      updatedAt
    }
  }
`;

// ==================== PACKAGE ↔ PROJECT LINK MUTATIONS & QUERIES ====================

// PACKAGE ↔ PROJECT LINKS (Arbeitsbeispiele mit Paketen verknüpfen)
// ============================================================================

export const CREATE_PACKAGE_PROJECT_LINK = gql`
  mutation CreatePackageProjectLink($input: CreatePackageProjectLinkInput!) {
    createPackageProjectLink(input: $input) {
      id
      packageID
      projectID
      project {
        id
        title
        description
        images {
          url
          caption
          thumbnailUrl
          order
        }
        audios {
          url
          title
          artists
          genre
          coverImage
          order
          durationMs
        }
        status
      }
      createdAt
    }
  }
`;

export const DELETE_PACKAGE_PROJECT_LINK = gql`
  mutation DeletePackageProjectLink($input: DeletePackageProjectLinkInput!) {
    deletePackageProjectLink(input: $input) {
      id
    }
  }
`;

export const GET_PACKAGE_PROJECT_LINKS = gql`
  query GetPackageProjectLinks($packageID: ID!) {
    packageProjectLinksByPackageID(packageID: $packageID) {
      items {
        id
        packageID
        projectID
        project {
          id
          title
          description
          images {
            url
            caption
            thumbnailUrl
            order
          }
          audios {
            url
            title
            artists
            genre
            coverImage
            order
            durationMs
          }
          status
        }
      }
    }
  }
`;
